<template>
    <div
        class="widget h-100 d-flex flex-column justify-content-start align-items-center px-0 px-md-3 py-1 m-0 m-sm-1"
    >
        <div
            :id="id"
            class="prog-circle d-flex flex-column justify-content-center position-relative"
            style=""
        >
            <div
                class="position-absolute font-weight-bold w-100 h-100 d-flex flex-column justify-content-center align-items-center"
            >
                <h5 class="mb-0">{{ progress }}</h5>
                <p class="text-uppercase font-weight-light mb-0" style="font-size: 0.8rem;">
                    {{ time }}
                </p>
            </div>
        </div>
        <small class="text-uppercase font-weight-bold text-center mb-0">{{ title }}</small>
        <small class="text-uppercase font-weight-light text-center mb-0">{{ subtitle }}</small>
    </div>
</template>

<script>
export default {
    name: "AverageScore",
    props: ["title", "subtitle", "progress", "max", "time", "color", "id"],
    mounted() {
        this.$forceUpdate();
        let p = new this.ProgressBar.Circle(`#${this.id}`, {
            strokeWidth: 7,
            easing: "easeInOut",
            duration: 1400,
            color: this.color,
            trailColor: "#c6c6c8",
            trailWidth: 7,
            svgStyle: null,
        });
        p.animate(this.progress / this.max);
    },
};
</script>

<style scoped lang="scss">
.widget {
    background-color: #fff;
    > .prog-circle {
        min-width: 40px;
        min-height: 40px;
        max-width: 40px;
        max-height: 40px;
    }
    > .prog-circle > div > h5 {
        font-family: "Roboto Condensed", sans-serif;
    }
    > p {
        padding-top: 0.5rem;
        font-size: 0.5rem;
        line-height: 1;
        word-spacing: 200px;
    }
}

@media screen and (min-width: 768px) {
    .widget {
        > .prog-circle {
            min-width: 70px;
            min-height: 70px;
            max-width: 70px;
            max-height: 70px;
        }
        > .prog-circle > div > h5 {
            font-size: 2rem;
        }
        > p {
            font-size: 0.7rem;
        }
    }
}

@media screen and (min-width: 992px) {
    .widget {
        > .prog-circle {
            min-width: 100px;
            min-height: 100px;
            max-width: 100px;
            max-height: 100px;
        }
        > .prog-circle > h5 {
            font-size: 3rem;
        }
        > p {
            font-size: 1rem;
        }
    }
}
</style>
